import { render, staticRenderFns } from "./OrdersEmails.vue?vue&type=template&id=5fd9b536"
import script from "./OrdersEmails.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersEmails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports